import { CallToAction } from '@/components/CallToAction'
import { FAQ } from '@/components/FAQ'
import { Features } from '@/components/Features'
import { Footer } from '@/components/Footer'
import { Hero } from '@/components/Hero'
import { HowItWorks } from '@/components/HowItWorks'
import { Pricing } from '@/components/Pricing'
import { Security } from '@/components/Security'
import { SEO } from '@/components/SEO'
import { Stats } from '@/components/Stats'
import { SEO_CONFIG, STRUCTURED_DATA_CONFIG } from '@/constants/seo'
import { VIDEOS } from '@/constants/videos'

export const Home = () => {
    return (
        <>
            <SEO
                title={SEO_CONFIG.defaultTitle}
                description={SEO_CONFIG.defaultDescription}
                keywords={SEO_CONFIG.keywords}
                canonical={SEO_CONFIG.siteUrl}
                ogImage={SEO_CONFIG.ogImage}
                structuredData={STRUCTURED_DATA_CONFIG.softwareApplication}
            />
            <Hero/>
            <Stats/>
            <HowItWorks videos={VIDEOS.howItWorks}/>
            <Features/>
            <Security/>
            <Pricing/>
            <FAQ/>
            <CallToAction/>
            <Footer/>
        </>
    )
}
